import {
    PositionModel,
    Side,
    ContractDate,
    CommodityModel,
    LocationModel
} from '../Generated/Commodity-Management-Api';

export const filterBuyPositions = (positions: PositionModel[]): PositionModel[] => {
    return positions.filter(p => p.side === Side.Buy);
};

export const filterSellPositions = (positions: PositionModel[]): PositionModel[] => {
    return positions.filter(p => p.side === Side.Sell);
};

export const filterByCommodity = (
    positions: PositionModel[],
    commodityId: number
): PositionModel[] => {
    return positions.filter(p => p.commodity.commodityId === commodityId);
};

export const filterByCommodityModel = (
    positions: PositionModel[],
    commodity: CommodityModel
): PositionModel[] => {
    return filterByCommodity(positions, commodity.commodityId);
};

export const filterByBudgetDate = (
    positions: PositionModel[],
    budgetDate: ContractDate
): PositionModel[] => {
    return positions.filter(p =>
        p.budgetDate?.year === budgetDate.year &&
        p.budgetDate?.month === budgetDate.month
    );
};

export const filterByLocation = (
    positions: PositionModel[],
    locationId: number
): PositionModel[] => {
    return positions.filter(p => p.location.locationId === locationId);
};

export const filterByLocationModel = (
    positions: PositionModel[],
    location: LocationModel
): PositionModel[] => {
    return filterByLocation(positions, location.locationId);
};

export const getUniqueCommodities = (positions: PositionModel[]): CommodityModel[] => {
    const commodityMap = new Map<number, CommodityModel>();

    positions.forEach(p => {
        if (!commodityMap.has(p.commodity.commodityId)) {
            commodityMap.set(p.commodity.commodityId, p.commodity);
        }
    });

    return Array.from(commodityMap.values());
};

export const getUniqueLocations = (positions: PositionModel[]): LocationModel[] => {
    const locationMap = new Map<number, LocationModel>();

    positions.forEach(p => {
        if (!locationMap.has(p.location.locationId)) {
            locationMap.set(p.location.locationId, p.location);
        }
    });

    return Array.from(locationMap.values());
};

export const getUniqueBudgetDates = (positions: PositionModel[]): ContractDate[] => {
    const dateMap = new Map<string, ContractDate>();

    positions.forEach(p => {
        const key = `${p.budgetDate?.year}-${p.budgetDate?.month}`;
        if (!dateMap.has(key) && p.budgetDate) {
            dateMap.set(key, p.budgetDate);
        }
    });

    return Array.from(dateMap.values());
};

export const contractDateEquals = (a: ContractDate | undefined, b: ContractDate | undefined): boolean => {
    if (!a || !b) return false;
    return a.year === b.year && a.month === b.month;
};